import { Gender } from "../../../../../../react-core/Enums/Gender";
import { CompanyType } from "../../../../../../Wrap/Constants/Enums/Customer/CompanyType";
import { CustomerType } from "../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { FATCABusinessType } from "../../../../../../Wrap/Constants/Enums/Customer/FATCABusinessType";
import { LawType } from "../../../../../../Wrap/Constants/Enums/Customer/LawType";
import { RelationshipType } from "../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";

export const steppers = {
    clientTypeSelection: "Client type",
    clientDetails: "Client details",
};

export const CustomerTypeArrays = [
    CustomerType.Individual,
    CustomerType.Trust,
    CustomerType.CorporateTrust,
    CustomerType.Child
];

export const CustomerTypeArraysMap = {
    [CustomerType.Individual]: "Individual",
    [CustomerType.Trust]: "Trust",
    [CustomerType.CorporateTrust]: "Corporate",
    [CustomerType.Company]: "Company",
    [CustomerType.Child]: "Child",
};


export const enum NeworExisting {
    New = 1,
    Existing = 2,
}
export const NeworExistingOption = [NeworExisting.New, NeworExisting.Existing];

export const NeworExistingMap = {
    [NeworExisting.New]: "New",
    [NeworExisting.Existing]: "Existing",
};

export const LawtoApplyOption = [LawType.ScottishLaw, LawType.EnglishLaw, LawType.NorthernIrishLaw];

export const LawtoApplyMap = {
    [LawType.ScottishLaw]: "Scottish law",
    [LawType.EnglishLaw]: "English law",
    [LawType.NorthernIrishLaw]: "Northern Irish law",
};

export const enum RelationshiptoTrust {
    IndividualTrustee = 1,
    CorporateTrustee = 2,
    Settlor = 3,
    Beneficiary = 4,
}
export const RelationshiptoTrustOption = [
    RelationshiptoTrust.IndividualTrustee,
    RelationshiptoTrust.CorporateTrustee,
    RelationshiptoTrust.Settlor,
    RelationshiptoTrust.Beneficiary,
];

export const RelationshiptoTrustMap = {
    [RelationshiptoTrust.IndividualTrustee]: "Individual Trustee",
    [RelationshiptoTrust.CorporateTrustee]: "Corporate Trustee",
    [RelationshiptoTrust.Settlor]: "Settlor",
    [RelationshiptoTrust.Beneficiary]: "Beneficiary",
};

export const FATCABusinessTypeOption = [
    FATCABusinessType.NotSpecified,
    FATCABusinessType.InvestmentBody,
    FATCABusinessType.FFI,
    FATCABusinessType.RegisteredCharity,
    FATCABusinessType.PensionFund,
    FATCABusinessType.ActiveNFFE,
];

export const FATCABusinessTypeMap = {
    [FATCABusinessType.NotSpecified]: "Please select",
    [FATCABusinessType.InvestmentBody]: "Investment Body (Passive NFE/NFFE)",
    [FATCABusinessType.FFI]: "Financial Institution (FFI)",
    [FATCABusinessType.RegisteredCharity]: "Registered Charity",
    [FATCABusinessType.PensionFund]: "Pension Fund",
    [FATCABusinessType.ActiveNFFE]: "Actively Trading Non-Financial Services Business (Active NFFE)",
};

export const CompanyTypeOption = [
    CompanyType.NotSpecified,
    CompanyType.LtdCo,
    CompanyType.PLC,
    CompanyType.Partnership,
    CompanyType.LLP,
    CompanyType.TrustCo,
];

export const CorporateTrusteeCompanyTypeOption = [
    CompanyType.LtdCo,
    CompanyType.PLC,
    CompanyType.Partnership,
    CompanyType.LLP,
    CompanyType.TrustCo,
];

export const CompanyTypeMap = {
    [CompanyType.NotSpecified]: "Please select",
    [CompanyType.LtdCo]: "Ltd Co",
    [CompanyType.PLC]: "PLC",
    [CompanyType.Partnership]: "Partnership",
    [CompanyType.LLP]: "LLP",
    [CompanyType.TrustCo]: "TrustCo",
};

export const RelationshipTypeMap = {
    [RelationshipType.IndividualTrustee]: "Individual trustee",
    [RelationshipType.CorporateTrustee]: "Corporate trustee",
    [RelationshipType.Settlor]: "Settlor",
    [RelationshipType.Beneficiary]: "Beneficiary",
};

export const RelationshipTypeArray = [
    RelationshipType.IndividualTrustee,
    RelationshipType.CorporateTrustee,
    RelationshipType.Settlor,
    RelationshipType.Beneficiary,
];

export const TrustTypeMap = {
    GIFTPLAN: "Gift plan",
    DISCOUNTEDGIFTPLAN: "Discounted gift plan",
    LOANPLAN: "Loan plan",
};

export const ButtonLabels = {
    okLabel: "Ok",
    nextLabel: "Next",
    previousLabel: "Previous",
    createAnotherClient: "Create another client",
    quote: "New quote",
    newBusiness: "Start new business",
    addClient: "Add client",
    printReview: "Print review",
    backToDashboard: "Back to dashboard",
};

export const titleLabels = {
    networkLabel: "Network",
    firmLabel: "Firm",
    adviserLabel: "Assign an adviser",
    clientType: "Client type",
    titleLable: "Title",
    firstNameLabel: "First name(s)",
    middleNameLabel: "Middle name",
    surnameLabel: "Surname",
    dateOfBirthLabel: "Date of birth",
    emailLabel: "Email address",
    landLineLabel: "Landline number (optional)",
    mobilePhoneLabel: "Mobile number (optional)",
    genderLabel: "Gender",
    pleaseSelectLabel: "Please select",
    selectAdviser: "Select adviser",
    incompleteDataErrorMessage: "Please enter the details",
};

export const OrganisationMemberPopUpInfo = {
    moreTrusteesThanSettlors: "It is advised that the number of Trustees is greater than the number of Settlors.",
    line2: "Where Trust Type is Existing, then a Settlor will not be required.",
    line3:
        "Minimum age of a Settlor for a Discounted Gift Plan is 50 years old, and max age is 6 months prior to 90th Birthday.",
    line4: "A beneficiary is not required to be entered here if the intended Trust Category will be Discretionary.",
    atLeastOneTrustee: "At least one Trustee is required.",
    atLeastOneSettlor: "A settlor will be required if this is a 'New' Trust.",
    noBeneficiary:
        "For new trusts where trust category is Absolute or Flexible a minimum of 1 beneficiary is required.",
    atLeastOneCorporateTrustee: "At least one Corporate Trustee is required for this type of Trust.",
    settlorToolTip:
        "If you are opening a Discounted Gift Plan, the minimum age of a Settlor on this type of Trust is 50 years old. Additionally, the maximum age is 6 months before the Individuals 90th birthday.",
    addMoreTrust: "Do you wish to add more Trust members?",
    moreThanTwoSettlors: "Could not add more than two settlors.",
    removeBoth: "This trust member will be removed from the Trust.",
    flexibleBeneficary: "There must be a minimum of one beneficiary at any time when the trusts category is Flexible.",
    shareOfTrustWarning: "Share of trusts should sum up to 100%.",
    nonUKResidence: "Trust member is not a U.K. resident.",
    removeTrusteeWarning:
        "You cannot remove the Individual Trustee role only here. Please remove both roles in order to proceed.",
};

export const OldNewTrustWizard = "/clients/newbusiness/TrustCreate.aspx";
export const AddAnotherClient = "/wpadviser/en-gb/dashboard/home/main/client/addclient/client-type";
